import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import * as ReactRouterDom from 'react-router-dom';

let initialized = false;

function initializeGA() {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (!initialized && measurementId) {
    ReactGA.initialize(measurementId);
    initialized = true;
  }
}

function usePageTracking() {
  const location = ReactRouterDom.useLocation();

  useEffect(() => {
    initializeGA();
    ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
  }, [location]);
}

export default usePageTracking;
